export enum SellingProductsTodayOptionsIds {
  StartFirstEcommerceBusiness = 'start_my_first_ecommerce_business',
  GrowMyOnlineBusiness = 'grow_my_online_business',
  SellMerchToMyFollowers = 'sell_merch_to_my_followers',
  BecomeAnAffiliate = 'become_an_affiliate',
  OrderCustomerProductForMyself = 'order_customer_product_for_myself',
  JustPlayingAround = 'just_playing_around',
}

export const SellingProductsTodayOptions = [
  { id: SellingProductsTodayOptionsIds.StartFirstEcommerceBusiness, name: 'txt_start_my_first_ecommerce_business' },
  { id: SellingProductsTodayOptionsIds.GrowMyOnlineBusiness, name: 'txt_grow_my_online_business' },
  { id: SellingProductsTodayOptionsIds.SellMerchToMyFollowers, name: 'txt_sell_merch_to_followers' },
  { id: SellingProductsTodayOptionsIds.BecomeAnAffiliate, name: 'txt_become_an_affiliate' },
  {
    id: SellingProductsTodayOptionsIds.OrderCustomerProductForMyself,
    name: 'txt_order_customer_product_for_myself',
  },
  { id: SellingProductsTodayOptionsIds.JustPlayingAround, name: 'txt_playing_around' },
];
